import { createRouter } from "@tanstack/react-router";

import { reportError } from "@/lib/monitoring";
import { queryClient } from "@/lib/query";
import { routeTree } from "@/routes/root";

// 쿼리는 legacy(Next searchParams)처럼 문자열 그대로 — 기본 파서는 JSON 파싱해 `?q=true` 가 불리언이 된다. 반복 키는 배열.
export const parseSearch = (searchStr: string): Record<string, unknown> => {
  const search: Record<string, string | string[]> = {};
  new URLSearchParams(searchStr).forEach((value, key) => {
    const prev = search[key];
    search[key] = prev === undefined ? value : Array.isArray(prev) ? [...prev, value] : [prev, value];
  });
  return search;
};

// 링크도 URLSearchParams 로 — 문자열에 JSON 따옴표를 붙이지 않고, 배열은 반복 키, undefined·null 은 뺀다.
export const stringifySearch = (search: Record<string, unknown>): string => {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(search)) {
    for (const item of Array.isArray(value) ? value : [value]) {
      if (item !== undefined && item !== null) params.append(key, String(item));
    }
  }
  const searchStr = params.toString();
  return searchStr ? `?${searchStr}` : "";
};

export const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: false,
  scrollRestoration: true,
  parseSearch,
  stringifySearch,
  // 경로 경계(errorComponent)가 잡은 화면·loader 오류 — 5xx·예상 못 한 것만 Sentry 로(main 이 켰을 때만).
  defaultOnCatch: (error) => reportError(error),
});
